// Premium Portal Header Component - Consistent branding across all portal pages
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function PortalHeader({ title, showBack = true, backTo = '/dashboard' }) {
  return (
    <header className="sticky top-0 z-30 bg-[#030303]/90 backdrop-blur-xl border-b border-white/[0.06]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
        {showBack ? (
          <Link to={backTo} className="flex items-center gap-2 text-zinc-400 hover:text-white transition-colors">
            <ArrowLeft className="w-5 h-5" />
            <span className="hidden sm:inline font-['Manrope'] text-sm">Volver</span>
          </Link>
        ) : (
          <div className="w-16" />
        )}
        <img 
          src="/manklar-logo-white.png" 
          alt="Manklar" 
          className="h-8 sm:h-9 drop-shadow-[0_0_20px_rgba(255,255,255,0.1)]"
        />
        <div className="w-16" />
      </div>
    </header>
  );
}

// Premium Loading State
export function PortalLoading() {
  return (
    <div className="min-h-screen bg-[#030303] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <img src="/manklar-logo-white.png" alt="Manklar" className="h-10 opacity-50" />
        <div className="w-8 h-8 border-2 border-white/20 border-t-white rounded-full animate-spin" />
      </div>
    </div>
  );
}

// Equipment image mapping
export const EQUIPMENT_IMAGES = {
  'KAJAAL': '/equipment-kajaal.png',
  'TIKAL': '/equipment-tikal.png',
  'TIKAL S': '/equipment-tikal-s.png',
  'TIKAL-S': '/equipment-tikal-s.png',
  'CHAAK': '/equipment-chaak.png',
  'CHÁAK': '/equipment-chaak.png',
};

export function getEquipmentImage(modelName) {
  if (!modelName) return '/equipment-tikal.png';
  const upperName = modelName.toUpperCase();
  for (const [key, value] of Object.entries(EQUIPMENT_IMAGES)) {
    if (upperName.includes(key)) return value;
  }
  return '/equipment-tikal.png';
}

// Format maintenance date - never show negative
export function formatMaintenanceDate(dateString) {
  if (!dateString) return { text: 'Pendiente de programar', status: 'pending' };
  
  const date = new Date(dateString);
  const today = new Date();
  const diffTime = date - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays < 0) {
    return { 
      text: 'Vencido - Solicitar revisión', 
      status: 'overdue',
      date: date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })
    };
  }
  
  if (diffDays === 0) {
    return { text: 'Hoy', status: 'today' };
  }
  
  if (diffDays <= 7) {
    return { text: `En ${diffDays} día${diffDays > 1 ? 's' : ''}`, status: 'soon' };
  }
  
  if (diffDays <= 30) {
    return { text: `En ${diffDays} días`, status: 'upcoming' };
  }
  
  return { 
    text: date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' }), 
    status: 'scheduled' 
  };
}
